module.exports = __webpack_public_path__ + "static/media/submenu-clientes.84bc70ba.svg";